import { render, staticRenderFns } from "./ServicesPage.vue?vue&type=template&id=47553f10&scoped=true&"
import script from "./ServicesPage.vue?vue&type=script&lang=ts&"
export * from "./ServicesPage.vue?vue&type=script&lang=ts&"
import style0 from "./ServicesPage.vue?vue&type=style&index=0&id=47553f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47553f10",
  null
  
)

export default component.exports